import {
	Ban,
	CheckCircle,
	CircleDot,
	Clock,
	ShieldX,
	XCircle,
} from "lucide-react";
import type { FC } from "react";

import { StatusBadge, type StatusType } from "src/components/status-badge";
import type { OrderStatus } from "src/types";

interface Props {
	status: OrderStatus;
}

const statusConfig: Record<
	OrderStatus,
	{ label: string; type: StatusType; icon: typeof CheckCircle }
> = {
	paid: { label: "Paid", type: "success", icon: CheckCircle },
	partially_paid: { label: "Partially Paid", type: "info", icon: CircleDot },
	pending: { label: "Pending", type: "warning", icon: Clock },
	expired: { label: "Expired", type: "error", icon: XCircle },
	cancelled: { label: "Cancelled", type: "default", icon: Ban },
	aml_rejected: { label: "AML Rejected", type: "danger", icon: ShieldX },
};

const OrderStatusLabel: FC<Props> = ({ status }) => {
	const config = statusConfig[status] ?? {
		label: status,
		type: "default" as const,
		icon: Clock,
	};

	return (
		<StatusBadge type={config.type} icon={config.icon}>
			{config.label}
		</StatusBadge>
	);
};

export default OrderStatusLabel;
